import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { type Unit } from '#src/lib/style.ts';

type Direction = 'horizontal' | 'vertical' | 'auto';

type Props = {
  children: ReactNode;
  direction?: Direction;
  wrap?: boolean;
  gap?: Unit;
  minChildWidth?: number;
  className?: string;
};

const Root = styled(Horizontal)`
  align-items: stretch;

  &[data-wrap='true'] {
    flex-wrap: wrap;
  }

  &[data-direction='horizontal'] > * {
    flex: 1 1 auto;
  }

  &[data-direction='auto'] > * {
    flex: 1 1 var(--actions-min-child-width, 160px);
  }

  &[data-direction='vertical'] {
    flex-direction: column;
  }
`;

export const Actions = ({
  children,
  direction = 'auto',
  wrap = true,
  gap = 2,
  minChildWidth,
  className,
}: Props) => (
  <Root
    gap={gap}
    data-direction={direction}
    data-wrap={wrap}
    className={className}
    style={
      minChildWidth
        ? ({
            '--actions-min-child-width': `${minChildWidth}px`,
          } as CSSProperties)
        : undefined
    }
  >
    {children}
  </Root>
);
